export default {
  tips: {
    areaNoPermission:
      'Playturbo的视频和图片制作服务在您所在的国家/地区不可用。',
  },
  useless: '无法使用',
}
